export enum DashboardRequestKeys {
  Insights = 'insights',
}
